import { Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SEVERITY_BY_STATUS = {
  valid: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

const TITLE_KEYS = {
  pending: {
    valid: 'organizations.update.checkSequence.validTitle',
    info: 'organizations.update.checkSequence.infoTitle',
    warning: 'organizations.update.checkSequence.warningTitle',
    error: 'organizations.update.checkSequence.errorTitle',
  },
  current: {
    valid: 'organizations.update.checkSequence.currentValidTitle',
    info: 'organizations.update.checkSequence.currentInfoTitle',
    warning: 'organizations.update.checkSequence.currentWarningTitle',
    error: 'organizations.update.checkSequence.currentErrorTitle',
  },
};

const SEVERITY_LABEL_KEYS = {
  error: 'organizations.update.checkSequence.severityError',
  warning: 'organizations.update.checkSequence.severityWarning',
  info: 'organizations.update.checkSequence.severityInfo',
};

const CheckSequenceValidationBanner = ({
  verdict,
  loading,
  failed,
  localErrorMessage,
  showMinimum,
}) => {
  const { t } = useTranslation();

  if (localErrorMessage) {
    return (
      <Alert severity='error' sx={{ mt: 2 }}>
        {localErrorMessage}
      </Alert>
    );
  }

  if (failed) {
    return (
      <Alert severity='warning' sx={{ mt: 2 }}>
        {t('organizations.update.checkSequence.unavailable')}
      </Alert>
    );
  }

  if (!verdict) {
    return null;
  }

  const severity = SEVERITY_BY_STATUS[verdict.status] ?? 'info';

  const titles = verdict.isChange ? TITLE_KEYS.pending : TITLE_KEYS.current;
  const titleKey = titles[verdict.status];
  const findings = verdict.findings ?? [];
  const hasMixedSeverities = new Set(findings.map((f) => f.severity)).size > 1;

  return (
    <Alert
      severity={severity}
      sx={{ mt: 2, opacity: loading ? 0.6 : 1 }}
      data-testid='check-sequence-validation'>
      {titleKey && <AlertTitle>{t(titleKey)}</AlertTitle>}
      {findings.map((finding) => (
        <Typography variant='body2' key={`${finding.code}-${finding.message}`}>
          {hasMixedSeverities && SEVERITY_LABEL_KEYS[finding.severity] && (
            <Typography component='span' variant='body2' fontWeight={600}>
              {t(SEVERITY_LABEL_KEYS[finding.severity])} &middot;{' '}
            </Typography>
          )}
          {finding.customPaymentTypeId != null && (
            <Typography component='span' variant='body2' fontWeight={600}>
              {t('organizations.update.checkSequence.customPaymentType')}{' '}
            </Typography>
          )}
          {finding.message}
        </Typography>
      ))}
      {showMinimum && verdict.minimumStartingCheckNumber != null && (
        <Typography variant='body2'>
          {t('organizations.update.checkSequence.minimum', {
            value: verdict.minimumStartingCheckNumber,
          })}
        </Typography>
      )}
    </Alert>
  );
};

export default CheckSequenceValidationBanner;
